import { render } from "./customerNoteCreate.vue?vue&type=template&id=18d92d76"
import script from "./customerNoteCreate.vue?vue&type=script&lang=js"
export * from "./customerNoteCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nice-life-contract/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__